<template>
  <v-form v-model="dataIsValid">
    <v-row>
      <v-col cols="6" md="5" offset-md="1">
        <div class="mb-3 body-1 font-weight-medium" v-if="!editDisable">
          {{$t('pages.agreementConclusionChangeOwner.inputObjectInfo')}}
        </div>
      </v-col>
      <v-col cols="6" md="5" class="pt-7">
        <v-radio-group v-model="radioGroup">
          <v-radio
            v-for="(item, index) in radioItems"
            :key="index"
            :label="item.label"
            :value="item.value"
            :disabled="editDisable"
          ></v-radio>
        </v-radio-group>
      </v-col>
      <v-col cols="6" md="4" offset-sm="1" class="pt-0">
        <div class="mb-3 body-1 font-weight-medium">
          {{$t('pages.agreementConclusionChangeOwner.typeObject')}}:
        </div>
        <v-select
          :items="buildItems"
          v-model="buildSelect"
          item-text="text"
          :loading="!buildItems.length"
          :disabled="!buildItems.length || editDisable"
          no-data-text="Загрузка"
          return-object
          outlined
        ></v-select>

        <div
          v-if="
            buildSelect.text === $t('pages.agreementConclusionChangeOwner.landPlot')||
            buildSelect.text === $t('pages.agreementConclusionChangeOwner.gardenHouse') ||
            buildSelect.text === $t('pages.agreementConclusionChangeOwner.privateHouse')
          "
        >
          <div class="mb-3 body-1 font-weight-medium">
            {{$t('pages.agreementConclusionChangeOwner.gardenObject')}}:
          </div>
          <v-select
            :items="objectLocateGardenItems"
            v-model="objectLocateSelect"
            item-text="text"
            :loading="!objectLocateGardenItems.length"
            :disabled="!objectLocateGardenItems.length || editDisable"
            no-data-text="Загрузка"
            return-object
            outlined
          ></v-select>
        </div>

        <div
          v-if="
            buildSelect.text !== $t('pages.agreementConclusionChangeOwner.garage') &&
            buildSelect.text !== $t('pages.agreementConclusionChangeOwner.landPlot') &&
            buildSelect.text !== $t('pages.agreementConclusionChangeOwner.gardenHouse') &&
            buildSelect.text !== $t('pages.agreementConclusionChangeOwner.detachedGarage')  &&
            buildSelect.text !== $t('pages.agreementConclusionChangeOwner.bathHouse') &&
            buildSelect.text !== $t('pages.agreementConclusionChangeOwner.barn')
          "
        >
          <div class="mb-3 body-1 font-weight-medium">
            {{$t('pages.agreementConclusionChangeOwner.square')}}: *
          </div>
          <v-text-field
            v-model="totalArea"
            outlined
            type="number"
            :rules="notEmptyRule.concat(minValue0)"
            :disabled="editDisable"
          ></v-text-field>

          <div class="mb-3 body-1 font-weight-medium">
            {{$t('pages.agreementConclusionChangeOwner.floors')}}:
          </div>
          <v-text-field
            v-model="floor"
            outlined
            :rules="minValue0"
            type="number"
            :disabled="editDisable"
          ></v-text-field>

          <div class="mb-3 body-1 font-weight-medium">{{$t('pages.agreementConclusionChangeOwner.rooms')}}: *</div>
          <v-text-field
            v-model="numberRooms"
            :rules="notEmptyRule.concat(minValue1, isInteger)"
            :hint="$t('pages.agreementConclusionChangeOwner.minValue')"
            persistent-hint
            outlined
            :disabled="editDisable"
          ></v-text-field>

          <div class="mb-3 body-1 font-weight-medium">
            {{$t('pages.agreementConclusionChangeOwner.residents')}}: *
          </div>
          <v-text-field
            v-model="numberInhabitants"
            outlined
            type="number"
            :rules="notEmptyRule.concat(isInteger, minValue1)"
            :hint="$t('pages.agreementConclusionChangeOwner.minValue')"
            persistent-hint
            :disabled="editDisable"
          ></v-text-field>
        </div>

        <div
          v-if="
            buildSelect.text === $t('pages.agreementConclusionChangeOwner.garage') ||
            buildSelect.text === $t('pages.agreementConclusionChangeOwner.landPlot')  ||
            buildSelect.text === $t('pages.agreementConclusionChangeOwner.gardenHouse')  ||
            buildSelect.text === $t('pages.agreementConclusionChangeOwner.detachedGarage')  ||
            buildSelect.text === $t('pages.agreementConclusionChangeOwner.bathHouse')  ||
            buildSelect.text === $t('pages.agreementConclusionChangeOwner.barn')
          "
        >
          <div class="mb-3 body-1 font-weight-medium">
            {{$t('pages.agreementConclusionChangeOwner.square')}}:
          </div>
          <v-text-field
            v-model="totalArea"
            outlined
            type="number"
            :disabled="editDisable"
          ></v-text-field>

          <div class="mb-3 body-1 font-weight-medium">
             {{$t('pages.agreementConclusionChangeOwner.floors')}}:
          </div>
          <v-text-field
            v-model="floor"
            outlined
            type="number"
            :disabled="editDisable"
          ></v-text-field>

          <div class="mb-3 body-1 font-weight-medium">{{$t('pages.agreementConclusionChangeOwner.rooms')}}:</div>
          <v-text-field
            v-model="numberRooms"
            persistent-hint
            outlined
            type="number"
            :disabled="editDisable"
          ></v-text-field>

          <div class="mb-3 body-1 font-weight-medium">
            {{$t('pages.agreementConclusionChangeOwner.residents')}}:
          </div>
          <v-text-field
            v-model="numberInhabitants"
            outlined
            type="number"
            persistent-hint
            :disabled="editDisable"
          ></v-text-field>
        </div>

        <div class="mb-3 body-1 font-weight-medium">
          {{$t('pages.agreementConclusionChangeOwner.tariffType')}}:
        </div>
        <v-select
          :items="tariffItems"
          v-model="tariffSelect"
          item-text="text"
          :loading="!tariffItems.length"
          :disabled="!tariffItems.length || editDisable"
          no-data-text="Загрузка"
          return-object
          outlined
        ></v-select>
        <div v-if="tariffType" class="mb-3 body-1 font-weight-medium">
          {{$t('pages.agreementConclusionChangeOwner.tariffTypeInfo')}}
      </div>
      </v-col>
      <v-col cols="6" md="4" offset-sm="1" class="pt-0">
        <div v-if="radioGroup === 'cadastre'">
          <template>
            <div class="mb-3 body-1 font-weight-medium">
              {{$t('pages.agreementConclusionChangeOwner.cadastre')}}: *
            </div>
            <v-text-field
              v-model="cadastralNumber"
              :rules="cadastreRule"
              v-mask="cadastreMask"
              outlined
              :disabled="editDisable"
            ></v-text-field>
          </template>
        </div>

        <div v-else-if="radioGroup === 'address'">
          <template>
            <div class="mb-3 body-1 font-weight-medium">{{$t('pages.agreementConclusionChangeOwner.cadastre')}}:</div>
            <v-text-field
              :disabled="editDisable"
              v-model="cadastralNumber"
              outlined
            ></v-text-field>
          </template>
        </div>

        <div class="mb-3 body-1 font-weight-medium">Адрес: *</div>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <span class="fs-12 red--text">{{ addressErrorText }}</span>
            <v-combobox
              :disabled="editDisable"
              v-bind="attrs"
              v-on="on"
              v-model="objAddress"
              outlined
              :search-input.sync="searcher"
              :items="res"
              item-text="value"
              :rules="objAddressRules"
            ></v-combobox>
          </template>
          <span v-if="objAddress.length > 0">
            {{ objAddress }}
          </span>
          <span v-else-if="objAddress.value != null">
            {{ objAddress.value }}
          </span>
          <span v-else> {{$t('pages.agreementConclusionChangeOwner.inputAddress')}} </span>
        </v-tooltip>
        <div
          v-if="radioGroup == 'cadastre'"
          class="mb-3 body-1 font-weight-medium"
        >
          {{$t('pages.agreementConclusionChangeOwner.selectArea')}}
        </div>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import AddressForm from "../components/partial/AddressForm1";
import { AxiosWrapper } from "@/assets/api/AxiosWrapper";
import { mask } from "vue-the-mask";
import { mapState } from "vuex";
import AddressFormCadastre from "../components/partial/AddressFormCadastre.vue";

export default {
  props: ["income", "formData"],
  directives: {
    mask,
  },
  components: {
    AddressForm,
    AddressFormCadastre,
  },
  data: () => ({
    objectAddress: null,
    cadastralNumber: "",
    floor: null,
    numberRooms: 0,
    numberInhabitants: 0,
    totalArea: null,
    searcher: "",
    objAddress: "",
    objAddressData: null,
    res: [],
    dataRequestCount: 0,
    licnumber: null,
    oko: "",
    BuildingType: null,
    objectLocateType: null,
    tariffType: null,
    openFirst: true,
    addressErrorText: "",
    // FORM SETTINGS
    dataIsValid: false, // Важное поле для работы визарда
    addressIsValid: false,
    radioGroup: "address",
    buildSelect: {},
    objectLocateSelect: {},
    tariffSelect: {},
    //mask
    okoMask: "####",
    cadastreMask: "##:##:######:###################",
  }),

  methods: {
    transferData() {
      // DATA
      this.$emit("transfer", {
        // objectAddress: this.objectAddress,
        cadastralNumber: this.cadastralNumber,
        floor: this.floor,
        numberRooms: this.numberRooms,
        numberInhabitants: this.numberInhabitants,
        totalArea: this.totalArea,
        licnumber: Number(this.licnumber),
        BuildingType: this.BuildingType,
        objectLocateType: this.objectLocateType,
        tariffType: this.tariffType,
        settingType: this.radioGroup,
        objAddress: this.objAddress,
        objAddressData: this.objAddressData,
      });
    },
    setValidation(value) {
      this.addressIsValid = value;
    },
    setAddress(payload) {
      this.objectAddress = {
        ...payload,
        addressType: "802740002",
      };
    },
    changeAddress(val) {
      if (val !== null) {
        var url =
          "https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/address";
        var token = "2f5e0ad569920be225048de64f9448a7b63e3952";
        var query = val;

        var options = {
          method: "POST",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: "Token " + token,
          },
          body: JSON.stringify({ query: query }),
        };

        this.res = [];

        fetch(url, options)
          .then((response) => response.text())
          .then((result) => {
            var resul = JSON.parse(result);

            for (let i = 0; i < resul.suggestions.length; i++) {
              this.res.push(resul.suggestions[i]);
            }
          })
          .catch((error) => console.log("error", error));
      }
    },

    moutedAddress(val) {
      if (val !== null) {
        this.objAddressData = null;
        var url =
          "https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/address";
        var token = "2f5e0ad569920be225048de64f9448a7b63e3952";
        var query = val;

        var options = {
          method: "POST",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: "Token " + token,
          },
          body: JSON.stringify({ query: query }),
        };

        fetch(url, options)
          .then((response) => response.text())
          .then((result) => {
            var resul = JSON.parse(result);
            if (resul.suggestions.length > 0) {
              var cadastreNum;

              if (resul.suggestions[0].data.flat_cadnum != null) {
                cadastreNum = resul.suggestions[0].data.flat_cadnum;
              } else if (resul.suggestions[0].data.house_cadnum != null) {
                cadastreNum = resul.suggestions[0].data.house_cadnum;
              } else {
                cadastreNum = resul.suggestions[0].data.stead_cadnum;
              }

              this.objAddressData = {
                addressType: "802740002",
                index: resul.suggestions[0].data.postal_code,
                region: resul.suggestions[0].data.region_fias_id,
                area: resul.suggestions[0].data.area_fias_id,
                city: resul.suggestions[0].data.city_fias_id,
                settlement: resul.suggestions[0].data.settlement_fias_id,
                street: resul.suggestions[0].data.street_fias_id,
                house: resul.suggestions[0].data.house_fias_id,
                flat: resul.suggestions[0].data.flat,
                cadastr: cadastreNum,
              };
            }
          })
          .catch((error) => console.log("error", error));
      }
    },
  },
  computed: {
    ...mapState({
      editDisable: (state) => state.statements.editDisable,
    }),
    minValue1(){ 
     return  [(value) => value >= 1 || this.$t('pages.agreementConclusionChangeOwner.minValue')]
    },
    minValue0(){ 
      return [(value) => value >= 0 || this.$t('pages.agreementConclusionChangeOwner.minValueZero')]
    },
    notEmptyRule(){
      return [(value) => value === 0 || !!value || this.$t('rules.fieldRequire')]
    },
    cadastreRule(){
      return [
      (value) => !!value || this.$t('rules.fieldRequire'),
      (v) => v.length > 13 || this.$t('rules.correctCadastr'),
      ]
    }, 
    isInteger(){
      return [(value) => value % 1 === 0 || this.$t('rules.isInteger')]
    },
    okoRules(){
      return  [
      (value) => [0, 4].includes(value.length) || this.$t('rules.length4')]
    },
    objAddressRules() { return [(v) => !!v || this.$t('rules.inputAddress')]},
    radioItems() {  
      return [
    {
      label: this.$t('pages.agreementConclusionChangeOwner.isAddress'),
      value: "address",
    },
    {
      label: this.$t('pages.agreementConclusionChangeOwner.isCadastre'),
      value: "cadastre",
    },
    ]
    },
    objectLocateGardenItems(){
       return [
      {
        text: this.$t('yes'),
        type: true,
      },
      {
        text: this.$t('no'),
        type: false,
      },
      ]
    },
     errorText()
    {  
      return this.$t('pages.agreementConclusionChangeOwner.correctAddress')
    },
    
    tariffItems() {
      return [
      {
        text: this.$t('pages.agreementConclusionChangeOwner.single'),
        type: "1",
      },
      {
        text: this.$t('pages.agreementConclusionChangeOwner.differential'),
        type: "2",
      },
      ]
    },
      buildItems() {
        return [
      {
        text: this.$t('pages.agreementConclusionChangeOwner.bathHouse'),
        type: "802740004",
      },
      {
        text: this.$t('pages.agreementConclusionChangeOwner.garage'),
        type: "802740003",
      },
      {
        text: this.$t('pages.agreementConclusionChangeOwner.landPlot'),
        type: "802740002",
      },
      {
        text: this.$t('pages.agreementConclusionChangeOwner.flat'),
        type: "802740001",
      },
      {
        text: this.$t('pages.agreementConclusionChangeOwner.room'),
        type: "802740008",
      },
      {
        text: this.$t('pages.agreementConclusionChangeOwner.gardenHouse'),
        type: "802740007",
      },
      {
        text: this.$t('pages.agreementConclusionChangeOwner.barn'),
        type: "802740005",
      },
      {
        text: this.$t('pages.agreementConclusionChangeOwner.privateHouse'),
        type: "802740000",
      },
      {
        text: this.$t('pages.agreementConclusionChangeOwner.detachedGarage'),
        type: "802740006",
      },
    ]
    }
  },
  created() {
    let keys = Object.keys(this.income);
    keys.forEach((key) => {
      this[key] = this.income[key];
    });
    if (this.BuildingType) {
      this.buildSelect = this.buildItems.find(
        (it) => it.type === this.BuildingType
      );
    }

    if (this.tariffType) {
      this.tariffSelect = this.tariffItems.find(
        (it) => it.type === this.tariffType
      );
    }

    if (this.objectLocateType == true || this.objectLocateType == false) {
      this.objectLocateSelect = this.objectLocateGardenItems.find(
        (it) => it.type === this.objectLocateType
      );
    }

    if (this.cadastralNumber) {
      this.radioGroup = "cadastre";
    } else if (this.objectAddress) {
      this.radioGroup = "address";
    }
  },
  watch: {
    dataIsValid: {
      immediate: true,
      handler: function (value) {
        this.$emit("lockFwdBtn", !value || !this.objAddressData);
      },
    },
    objAddress: {
      immediate: true,
      handler: function (value) {
        this.addressErrorText =
          this.objAddressData || this.openFirst ? "" : this.errorText;
        this.$emit("lockFwdBtn", !this.dataIsValid || !this.objAddressData);

      if(value == null){
          this.objAddress = "";
        }
      },
    },

    objAddressData: {
      immediate: true,
      handler: function (value) {
        this.addressErrorText =
          this.objAddressData || this.openFirst ? "" : this.errorText;
        this.openFirst = false;
        this.$emit("lockFwdBtn", !this.dataIsValid || !this.objAddressData);
      },
    },
    buildSelect: {
      immediate: true,
      handler: function (payload) {
        this.BuildingType = payload.type;
      },
    },
    objectLocateSelect: {
      immediate: true,
      handler: function (payload) {
        this.objectLocateType = payload.type;
      },
    },

    tariffSelect: {
      immediate: true,
      handler: function (payload) {
        this.tariffType = payload.type;
      },
    },

    radioGroup: {
      immediate: true,
      handler: function (value) {
        switch (value) {
          case "cadastre":
            //          this.objectAddress = {};
            break;
          case "address":
            this.cadastralNumber = "";
            break;
        }
      },
    },

    searcher(value) {
      if (value) {
        this.objAddress = value;
        this.objAddressData = null;

        var findResult = this.res.find(
          (x) => x.value.toLowerCase() == this.objAddress.toLowerCase()
        );
        if (findResult != null) {
          var cadastreNum;

          if (findResult.data.flat_cadnum != null) {
            cadastreNum = findResult.data.flat_cadnum;
          } else if (findResult.data.house_cadnum != null) {
            cadastreNum = findResult.data.house_cadnum;
          } else {
            cadastreNum = findResult.data.stead_cadnum;
          }

          this.objAddressData = {
            addressType: "802740002",
            index: findResult.data.postal_code,
            region: findResult.data.region_fias_id,
            area: findResult.data.area_fias_id,
            city: findResult.data.city_fias_id,
            settlement: findResult.data.settlement_fias_id,
            street: findResult.data.street_fias_id,
            house: findResult.data.house_fias_id,
            flat: findResult.data.flat,
            cadastr: cadastreNum,
          };

        }
      }
      if (this.dataRequestCount > 1) {
        this.changeAddress(value);
        this.dataRequestCount = 1;
      } else {
        this.dataRequestCount += 1;
      }
    },
  },
  mounted() {
    if (!this.BuildingType) {
      this.buildSelect = this.buildItems.find((it) => it.type === "802740001");
    }
    if (this.formData.BuildingType) {
      let keys = Object.keys(this.formData);
      keys.forEach((key) => {
        this[key] = this.formData[key];
      });
      if (this.BuildingType) {
        this.buildSelect = this.buildItems.find(
          (it) => it.type === this.BuildingType
        );
      }
      if (this.tariffType) {
        this.tariffSelect = this.tariffItems.find(
          (it) => it.type === this.tariffType
        );
      }

      if (this.objectLocateType == true || this.objectLocateType == false) {
        this.objectLocateSelect = this.objectLocateGardenItems.find(
          (it) => it.type === this.objectLocateType
        );
      }

      if (this.formData.settingType) {
        this.radioGroup = this.settingType;
      }
    }
    if (this.formData.objAddress) {
      this.objAddress = this.formData.objAddress;
    }

    if (this.objAddress.value != null) {
      this.moutedAddress(this.objAddress.value);
    } else {
      this.moutedAddress(this.objAddress);
    }
  },
};
</script>
